module.exports = __webpack_public_path__ + "img/page_title.bd2e47af.png";